import React, { useState } from 'react';

import { useSelector } from 'react-redux';

import Button from 'components/Button';
import Input from 'components/Input';
import { TEXT_COMMON, TEXT_USER_LIST } from 'constants/string/texts';

const SampleVideoListHeader = ({ options, onChange, onSubmit }) => {
  const [activeFilter, setActiveFilter] = useState(false);
  const { videoCategories } = useSelector((state) => state.videoCategory);
  const [categoryFilter, setCategoryFilter] = useState(null);

  const handleItemOverview = () => {
    const from = (options.page - 1) * options.page_size + 1;
    const to = from + options.page_size - 1;
    const total = options.total;

    return `${from} - ${to > total ? total : to} / ${total} ${TEXT_USER_LIST.PART}`;
  };

  const submitFilter = () => {
    onChange({ video_category_id: categoryFilter });
  };

  return (
    <>
      <div className="flex items-end justify-between gap-2 mt-2">
        <p className="text-sm opacity-85 text-gray-336">{handleItemOverview()}</p>
        <div className="flex space-x-4">
          <Button
            className={`text-sm filter w-35.5 h-10 ${activeFilter ? 'text-primary-346 border-primary-346' : ''}`}
            onClick={() => setActiveFilter(!activeFilter)}
            icon={
              activeFilter ? (
                <div className="relative mr-2.5">
                  {options.video_category_id && <div className="w-2 h-2 absolute top-0 right-0 bg-danger-229 rounded-full"></div>}
                  <img src={require('assets/resources/FilterAltActive.svg').default} alt="plus icon" width={18} height={18} />
                </div>
              ) : (
                <div className="relative mr-2.5">
                  {options.video_category_id && <div className="w-2 h-2 absolute top-0 right-0 bg-danger-229 rounded-full"></div>}
                  <img src={require('assets/resources/FilterAlt.svg').default} alt="plus icon" width={18} height={18} />
                </div>
              )
            }
            text={TEXT_USER_LIST.TEXT_FILTER}
            color="outline"
          />
        </div>
      </div>
      <div className={`${activeFilter ? 'h-54.25' : 'h-0'} overflow-hidden transition-all`}>
        <div className="w-full mt-6">
          <div className="border-2 border-primary-423 p-4 rounded-md h-47.25">
            <div className="flex-between-center">
              <p className="font-bold">{TEXT_USER_LIST.TEXT_FILTER}</p>
              <div className="cursor-pointer" onClick={() => setActiveFilter(false)}>
                <img src={require('assets/resources/Close.svg').default} alt="close" width={24} height={24} />
              </div>
            </div>
            <div className="w-full flex items-center gap-8 mt-4">
              <div className="w-64">
                <p className="text-sm mb-2">{'運動カテゴリ'}</p>
                <Input
                  onSelect={(e) => setCategoryFilter(e)}
                  onChange={(e) => setCategoryFilter(e)}
                  allowClear={true}
                  onClickClear={() => {
                    setCategoryFilter(null);
                    onChange({ video_category_id: null });
                  }}
                  value={categoryFilter}
                  name=""
                  classNameInput="!h-10"
                  className="!w-full"
                  type="dropdown"
                  placeholder={'運動カテゴリ'}
                  options={videoCategories}
                />
              </div>
            </div>
            <div className="mt-4 flex-end-center">
              <Button onClick={submitFilter} color="primary" type="button" className="w-20 h-8">
                <span className="text-sm">{TEXT_COMMON.EXECUTION}</span>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default React.memo(SampleVideoListHeader);
